import axios from 'axios'

import {URL_PREFIX} from '../config'

export const getNotifications = (page = 1, pageSize = 2147483647, params, CancelToken = null) => {
    return axios.get(URL_PREFIX + '/notifications/?page=' + page + '&page_size=' + pageSize, {
        params: params,
        cancelToken: CancelToken?.token
    })
}

export const getUserNotifications = (userId, page = 1, pageSize = 2147483647, CancelToken = null) => {
    return axios.get(URL_PREFIX + '/notification-users/?page=' + page + '&page_size=' + pageSize, {
        params: {userId: userId},
        cancelToken: CancelToken?.token
    })
}

export const postNotification = (params) => {
    return axios.post(URL_PREFIX + '/notifications/', params)
}

export const patchNotification = (id, params) => {
    return axios.patch(URL_PREFIX + '/notifications/' + id + '/', params)
}

export const patchUserNotification = (id, params) => {
    return axios.patch(URL_PREFIX + '/notification-users/' + id + '/', params)
}
